import { Constants } from "../Utils/Constants";

export class StatsHolder extends Phaser.GameObjects.Container {

	public bitmapText;
	protected background: Phaser.GameObjects.Graphics;
	protected spriteAnimation: Phaser.GameObjects.Sprite;

	constructor(scene: Phaser.Scene) {
		super(scene)

		this.background = new Phaser.GameObjects.Graphics(scene)
		this.add(this.background)
		this.bitmapText = new Phaser.GameObjects.BitmapText(scene, 0, 0, Constants.BITMAP_FONTS.MONTSERRAT)
		this.add(this.bitmapText)
	}

	get TextWidth(): number {
		return this.bitmapText.getTextBounds().global.width
	}

	get TextHeight(): number {
		return this.bitmapText.getTextBounds().global.height
	}

	DestroyAll(): void {
		if (this.background)
			this.background.destroy();
		if (this.bitmapText)
			this.bitmapText.destroy();
		if (this.spriteAnimation)
			this.spriteAnimation.destroy();

		this.removeAll(true);
		this.removeAll();
	}

	UpdateValues(width: number, height: number, fieldNumber: number, percentage: number, isHot: boolean = false, isCold: boolean = false): void {
		this.width = width;
		this.height = height;

		this.bitmapText.text = (percentage * 100).toFixed(2) + "%";
		this.bitmapText.setOrigin(0.5, 1);
		this.bitmapText.setTint(0xfcdb03);
		this.bitmapText.setFontSize(width / 4)
		this.bitmapText.setPosition(width / 2, height);

		let textWidth = this.bitmapText.getTextBounds().local.width;
		let textHeight = this.bitmapText.getTextBounds().local.height;

		this.background.clear();
		this.background.fillStyle(0x000000, 0.65);
		this.background.fillRect(this.bitmapText.x - (textWidth / 2), this.bitmapText.y - textHeight, textWidth, textHeight);

		if (isHot || isCold) {
			if (!this.spriteAnimation) {
				this.spriteAnimation = new Phaser.GameObjects.Sprite(this.scene, 0, 0, Constants.ANIMATIONS.HOT_ANIMATION);
				this.spriteAnimation.setOrigin(0);
				this.spriteAnimation.addToUpdateList();
				this.add(this.spriteAnimation);
			}

			this.spriteAnimation.setPosition(0, 0);
			this.spriteAnimation.active = true;

			if (fieldNumber == 0)//If its field 0, do not stretch the animation, not necessary just looks nicer - only applicable to hot since we have to move it up a bit
				this.spriteAnimation.setDisplaySize(width, height);
			else {
				this.spriteAnimation.x += 3;
				this.spriteAnimation.setDisplaySize(width - 3, height * 1.5);
			}

			if (isHot) {
				this.spriteAnimation.play("hotanim");
				if (fieldNumber != 0)//If its field 0, do not stretch the animation, not necessary just looks nicer - only applicable to hot since we have to move it up a bit
				{
					this.spriteAnimation.setOrigin(0, 1);
					this.spriteAnimation.setPosition(3, height - 3);
				}
				this.spriteAnimation.setAlpha(0, 0, 0.8, 0.8);//hot gets transparency on top
			}
			else {
				if (fieldNumber != 0) {
					this.spriteAnimation.y += 3;
				}
				this.spriteAnimation.setOrigin(0, 0);
				this.spriteAnimation.setPosition(3, 3);
				this.spriteAnimation.play("coldanim");
				this.spriteAnimation.setAlpha(0.8, 0.8, 0, 0);//cold gets transparency on bottom
			}

			this.sendToBack(this.spriteAnimation);
		}
		else if (this.spriteAnimation) {
			this.spriteAnimation.stop();
			this.spriteAnimation.setVisible(false);
			this.spriteAnimation.active = false;
		}
	}
}